import { action, observable } from 'mobx';
import Api from 'tm3-core/api';

class Tours {
  licenseAgreementName = 'licenseAgreement0419';
  tours: Record<string, boolean> = observable<Record<string, boolean>>({
    previewNewUx: false
  });

  @action.bound
  dontShowAgain(name: string) {
    this.tours[name] = true;
    return Api.put('/api/tours/skip', this.tours);
  }

  @action.bound
  setPreviewNewUX(previewNewUx: boolean) {
    this.tours['previewNewUx'] = previewNewUx;
    return Api.put('/api/tours/skip', this.tours);
  }
}

export default new Tours();
